import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import axios from "../../context/AxiosInstance";
import { AuthContext } from "../../context/AuthContext";
import { pieChartOptions } from "./statsChartSetup";

const PALETTE = ["#4f46e5", "#059669", "#d97706", "#dc2626", "#0891b2", "#7c3aed"];

const StatsTabEffectifs = ({ active }) => {
  const { token } = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!active || !token) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get("/statistiques/repartition", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data.data);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [active, token]);

  if (loading) {
    return <div className="stats-loading"><Spinner animation="border" /> Chargement effectifs…</div>;
  }
  if (!data) {
    return <div className="stats-empty">Données effectifs indisponibles.</div>;
  }

  const makeChart = (raw, title) => ({
    labels: raw.map((i) => i.label),
    datasets: [
      {
        label: title,
        data: raw.map((i) => i.value),
        backgroundColor: PALETTE.slice(0, raw.length),
        borderWidth: 2,
        borderColor: "#fff",
      },
    ],
  });

  const pieOpts = {
    ...pieChartOptions,
    plugins: {
      ...pieChartOptions.plugins,
      legend: {
        ...pieChartOptions.plugins.legend,
        position: "bottom",
      },
    },
  };

  const charts = [
    { title: "Type de contrat", key: "poste", data: data.poste },
    { title: "Genre", key: "genre", data: data.genre },
    { title: "Type de cadre", key: "type_cadre", data: data.type_cadre },
  ];

  return (
    <div className="stats-tab-content">
      <Row className="g-3">
        {charts.map(({ title, key, data: raw }) => (
          <Col md={4} key={key}>
            <div className="stats-panel stats-panel-chart">
              <h6 className="stats-panel-title text-center">{title}</h6>
              <div className="stats-chart-box stats-chart-pie">
                <Doughnut data={makeChart(raw, title)} options={pieOpts} />
              </div>
              <ul className="stats-legend-list">
                {raw.map((item, i) => (
                  <li key={item.label}>
                    <span className="dot" style={{ background: PALETTE[i % PALETTE.length] }} />
                    {item.label} <strong>{item.value}</strong>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default StatsTabEffectifs;
